import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {} from "reactstrap";
import { idfServiceIds, ezsServiceIds } from "../../../config/UserServicesList";
import { ApplicationState } from "../../../store";
import * as CreditActions from "../../../store/credit/actions";
import { IScore } from "../../../store/credit/types";
import { useAreServicesActive } from "../../../util/CommonServices";
import { useBureauPermission, fetchCreditData } from "../../../util/credit";
import * as httpClient from "../../../util/httpClient";
import CreditSimulatorFormField from "./CreditSimulatorFormField";
import CreditReportExpired from "../CreditReportExpired";
import { Notification } from "../../common/Notification";
import CreditStatus from "../CreditStatus";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

const CreditSimulator = () => {
    const { t: tLang } = useTranslation();
    const { register, setValue, errors, clearErrors, trigger } = useForm({ mode: "onBlur" });
    const dispatch = useDispatch();
    const bureauPermission = useBureauPermission();
    const requestCreditData = () => dispatch(CreditActions.actionCreators.requestCreditData(false, bureauPermission));
    const [currentScore, setcurrentScore] = useState(-1);
    const isTUUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userInfo?.isTUUser);
    const [isLoading, setIsLoading] = useState(false);
    // Start Active service base UI Display Logic
    const ids = [idfServiceIds.creditScoreSimulator, ezsServiceIds.tuCreditScoreSimulator, ezsServiceIds.tuCanadaCreditScoreSimulator];
    const isCreditScoreSimulatorActive = useAreServicesActive(ids);
    // End
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const creditScores = useSelector((state: ApplicationState) => {
        let scoreData = fetchCreditData(state.creditState.creditData, "score");

        if (scoreData == null) {
            scoreData = fetchCreditData(state.creditState.creditData);
        }
        
        function filterBureau(item: IScore) {
            return scoreData.IsIDFUser ? item.abbreviation === "TransUnion" : "Experian";
        }

        if (state.creditState.creditData && state.creditState.creditData.length > 0 && scoreData) {
            var filtered = scoreData.scores?.filter(filterBureau);
            if (currentScore === -1 && filtered != null && filtered.length > 0) {
                setcurrentScore(filtered[0]["risk-score"]);
            }
            return scoreData;
        } else {
            return null;
        }
    });

    const ensureDataFetched = () => {
        if (creditScores == null) {
            requestCreditData();
        }
    };

    const creditInquiryOptions = [1, 2, 3, 4, 5];
    const numberDays = [30, 60, 90];

    let accountAndCreditFields = [
        {
            category: "credit",
            name: "obtain-credit-card",
            description: tLang("creditSimulator.creditCardInfoSection.description.creditLimit"),
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
        {
            category: "credit",
            name: "close-oldest-credit-card",
            description: tLang("creditSimulator.creditCardInfoSection.description.cancelOldCard"),
            type: "checkbox-only",
            selected: false,
            pattern: "^[2-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.transferBalancePattern"),
        },
        {
            category: "credit",
            name: "transfer-credit-balances",
            description: tLang("creditSimulator.creditCardInfoSection.description.transferBalance"),
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
        {
            category: "credit",
            name: "increase-credit-card-limit",
            description: tLang("creditSimulator.creditCardInfoSection.description.increaseCreditCardLimit"),
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
        {
            category: "credit",
            name: "increase-credit-balance",
            description: tLang("creditSimulator.creditCardInfoSection.description.raiseBalance"),
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
        {
            category: "credit",
            name: "decrease-credit-balance",
            description: tLang("creditSimulator.creditCardInfoSection.description.lowerBalance"),
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
        {
            category: "credit",
            name: "pay-off-all-credit-cards",
            description: tLang("creditSimulator.creditCardInfoSection.description.payOffCreditCards"),
            type: "checkbox-only",
            selected: false,
            pattern: "",
            errorMessage: "",
        },

        {
            category: "account",
            name: "apply-for-credit-card",
            description: tLang("creditSimulator.accountInfoSection.description.inquiries"),
            type: "dropdown",
            options: creditInquiryOptions,
            value: "1",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "obtain-mortgage",
            description: tLang("creditSimulator.accountInfoSection.description.mortgage"),
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
        {
            category: "account",
            name: "obtain-personal-loan",
            description: tLang("creditSimulator.accountInfoSection.description.personalLoan"),
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
        {
            category: "account",
            name: "obtain-auto-loan",
            description: tLang("creditSimulator.accountInfoSection.description.autoLoan"),
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
        {
            category: "account",
            name: "one-account-past-due",
            description: tLang("creditSimulator.accountInfoSection.description.oneAccountPastDue"),
            type: "dropdown",
            options: numberDays,
            formatText: "Days",
            value: "30",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "all-accounts-past-due",
            description: tLang("creditSimulator.accountInfoSection.description.allAccountPastDue"),
            type: "dropdown",
            options: numberDays,
            formatText: "Days",
            value: "30",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "on-time-payment",
            description: tLang("creditSimulator.accountInfoSection.description.onTimePayment"),
            type: "middleInput",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "move-one-account-to-collection",
            description: tLang("creditSimulator.accountInfoSection.description.moveAccountToCollection"),
            type: "checkbox-only",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "add-tax-lien-public-record",
            description: tLang("creditSimulator.accountInfoSection.description.taxLienRecord"),
            type: "checkbox-only",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "add-foreclosure-public-record",
            description: tLang("creditSimulator.accountInfoSection.description.foreclosureRecord"),
            type: "checkbox-only",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "add-child-support-public-record",
            description: tLang("creditSimulator.accountInfoSection.description.childSupportRecord"),
            type: "checkbox-only",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "add-wage-garnishment-public-record",
            description: tLang("creditSimulator.accountInfoSection.description.wageGarnishmentRecord"),
            type: "checkbox-only",
            selected: false,
            pattern: "",
            errorMessage: "",
        },
        {
            category: "account",
            name: "declare-bankruptcy",
            description: tLang("creditSimulator.accountInfoSection.description.bankruptcy"),
            type: "checkbox-only",
            selected: false,
            pattern: "^[1-9]|[1-9][0-9]{1,3}$",
            errorMessage: tLang("creditSimulator.creditCardInfoSection.validationMessage.creditLimitPattern"),
        },
    ];

    useEffect(ensureDataFetched, []);

    const [stateAccountAndCreditFields, setStateAccountAndCreditFields] = useState(accountAndCreditFields);

    function submitForm(e: any) {
        e.preventDefault();
        let allObjArr = [...stateAccountAndCreditFields];
        var simulatorParamObj = {};
        let simulatedScore = "0";

        let selectedWithNoValueCounter = 0;
        allObjArr.map(function ({ name, value, selected }) {
            if (selected && value) {
                Object.defineProperty(simulatorParamObj, name, { value: value, writable: true, enumerable: true, configurable: true });
            }
            if (selected && !value) {
                selectedWithNoValueCounter++;
                // if selected, but no value is entered, trigger validation on all fields selected
                trigger(name);
            }
        });

        const requestBody = {
            "simulator-param": simulatorParamObj,
        };

        if (simulatorParamObj) {
            setIsLoading(true);
            httpClient
                .sendRequest("POST", `api/credit-monitoring/runCreditScoreSimulator`, requestBody)
                .then((data) => {
                    try {
                        var responseObj = JSON.parse(data);
                        if (responseObj.message === "OK") {
                            simulatedScore = responseObj.data["credit-score"];
                            const simulatedScoreElement = document.getElementById("simulated-score");
                            if (simulatedScoreElement) {
                                simulatedScoreElement.innerHTML = "<span>" + simulatedScore + "</span>";
                            }

                            const simulatedScoreDivider = document.getElementById("simulated-score-divider");
                            if (simulatedScoreDivider) {
                                simulatedScoreDivider.style.display = "block";
                            }
                            const titleSimulatedScore = document.getElementById("title-simulated-score");
                            if (titleSimulatedScore) {
                                titleSimulatedScore.style.display = "block";
                            }
                            const simulatedScoreEl = document.getElementById("simulated-score");
                            if (simulatedScoreEl) {
                                simulatedScoreEl.style.display = "block";
                            }
                        } else {
                            if (Object.keys(simulatorParamObj).length > 0) {
                                Notification({
                                    type: "error",
                                    title: "Credit Simulator",
                                    message: "Could not get the information for this selected filter. Please change the value and try again.",
                                    duration: 5,
                                });
                            } else if (selectedWithNoValueCounter > 0) {
                                Notification({
                                    type: "error",
                                    title: "Credit Simulator",
                                    message: "Please enter some values for modifying the simulated score and try again.",
                                    duration: 5,
                                });
                            } else {
                                Notification({
                                    type: "error",
                                    title: tLang("credit.tabs.creditSimulator"),
                                    message: tLang("creditSimulator.failedToastMessage"),
                                    duration: 5,
                                });
                            }
                        }
                        setIsLoading(false);
                    } catch (e) {
                        console.log(e);
                        setIsLoading(false);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    setIsLoading(false);
                });
        }
    }

    function onCheckboxChange(e: any) {
        var res = e.target.id.replace("chbox_", "");
        setValue(res, null);
        clearErrors(res);
        let newArr = [...stateAccountAndCreditFields];
        newArr.forEach(function (obj) {
            if (obj.name === res) {
                obj.selected = !obj.selected;
            }
            if (obj.type === "checkbox-only") {
                obj.value = obj.selected ? "1" : "0";
            }
        });

        setStateAccountAndCreditFields(newArr);
    }

    function onBlurText(e: any) {
        let newArr = [...stateAccountAndCreditFields];
        newArr.forEach(function (obj) {
            if (obj.name === e.target.name) {
                if (isNaN(Number(e.target.value))) {
                    setValue(e.target.name, parseInt(e.target.value) ? parseInt(e.target.value) : null);
                } else {
                    obj.value = e.target.value;
                }
            }
        });
        setStateAccountAndCreditFields(newArr);
    }

    function resetForm() {
        setStateAccountAndCreditFields(accountAndCreditFields);
        var divs = document.querySelectorAll(".disabled-on-reset");
        for (let i = 0; i < divs.length; i++) {
            const el = divs[i];
            if (el) {
                const attr = document.createAttribute("disabled");
                attr.value = "disabled";
                el.attributes.setNamedItem(attr);
            }
        }
        const element = document.getElementById("simulated-score");
        if (element) {
            element.innerHTML = "<span>0</span>";
        }
    }

    const renderMessageScreen = () => {
        if (creditScores != null && (creditScores["tu-status"] === "tu-thin-error" || creditScores["tu-status"] === "tu-down")) {
            return <CreditStatus status={creditScores["tu-status"]} />;
        } else if (creditScores != null && (creditScores["tu-status"] === "TU-Fulfill-Pull-Error")) {

            return (<div>
                <p> {tLang("credit.creditScore.creditScoreWidget.label.fulfill-pull-error-message1")}{" "}</p>
                <p>  {tLang("credit.creditScore.creditScoreWidget.label.fulfill-pull-error-message2")}{" "}</p>
                 <p> {tLang("credit.creditScore.creditScoreWidget.ssnAuthError.verifyYourIdentity.description2")}{" "}
                    <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber} </a>
                    {tLang("credit.creditScore.creditScoreWidget.ssnAuthError.verifyYourIdentity.description3")}
                </p></div >)
        } else if (creditScores != null && creditScores.IsExpired) {
            return <CreditReportExpired creditTabName="simulator" />;
        } else {
            return renderScoreScreen();
        }
    };
    const checkIsTUUser = (it: any) => {
        if (isTUUser) {
            if (it.name === "add-foreclosure-public-record" || it.name === "add-child-support-public-record" || it.name === "add-wage-garnishment-public-record") {
                return false;
            }
        }
        return true;
    };
    const renderScoreScreen = () => {
        return (
            <div className="box-content">
                <p> {tLang("creditSimulator.message")}</p>
                {creditScores != null ? (
                    <div className="row between-xs">
                        <div className="col-xs col-gutter-vertical flex-grow-null">
                            <ul className="list-reset margin-bottom-s credit-report-dates">
                                <li>
                                    <em className="las la-database icon-inline"></em> <strong>{tLang("creditSimulator.dataSourceLabel")}:</strong> TransUnion
                                </li>
                                <li>
                                    <em className="las la-calendar-day icon-inline"></em> <strong>{tLang("creditSimulator.updatedDataLabel")}:</strong>{" "}
                                    {creditScores["update-date"] && getFormattedDate(i18nService.get("Country"), creditScores["update-date"])}
                                </li>
                            </ul>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <div className="space-divider margin-top-l"></div>

                <form id="credit-score-simulator" action="javascript:void(0);">
                    <fieldset>
                        <legend>
                            <h3 className="content-title">Credit Cards</h3>
                        </legend>

                        {accountAndCreditFields
                            .filter((it) => it.category === "credit")
                            .map((field) => (
                                <div className="row between-sm" key={`key-${field.name}`}>
                                    <CreditSimulatorFormField
                                        active={field.name + "-on"}
                                        description={field.description}
                                        name={field.name}
                                        type={field.type || "money"}
                                        value={field.value}
                                        onBlur={onBlurText}
                                        onCheckboxChange={onCheckboxChange}
                                        register={register}
                                        errors={errors}
                                        pattern={field.pattern}
                                        errorMessage={field.errorMessage}
                                    />
                                </div>
                            ))}
                    </fieldset>

                    <div className="margin-vertical-l"></div>

                    <fieldset>
                        <legend>
                            <h3 className="content-title">Accounts</h3>
                        </legend>

                        {accountAndCreditFields
                            .filter((it) => it.category === "account" && checkIsTUUser(it))
                            .map((field) => (
                                <div className="row between-sm" key={`key-${field.name}`}>
                                    <CreditSimulatorFormField
                                        formatText={field.formatText || undefined}
                                        active={field.name + "-on"}
                                        description={field.description}
                                        name={field.name}
                                        options={field.options}
                                        type={field.type || "money"}
                                        value={field.value}
                                        onBlur={onBlurText}
                                        onCheckboxChange={onCheckboxChange}
                                        register={register}
                                        errors={errors}
                                        pattern={field.pattern}
                                        errorMessage={field.errorMessage}
                                    />
                                </div>
                            ))}
                    </fieldset>

                    <div className="margin-vertical-s"></div>

                    <div className="row center-xs">
                        <div className="col-xs flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                onClick={(e: any) => {
                                    submitForm(e);
                                    window.addToDataLayer({ event: "Simulate Score" });
                                }}
                                disabled={!!Object.keys(errors).length}
                            >
                                <span className="btn-text">{tLang("creditSimulator.simulateScoreButtonText")}</span>
                            </button>
                        </div>

                        <div className="col-xs flex-grow-null">
                            <button
                                type="reset"
                                className="btn-default btn-primary-outline"
                                onClick={() => {
                                    resetForm();
                                    window.addToDataLayer({ event: "Reset All Simulator Settings" });
                                }}
                            >
                                <span className="btn-text">{tLang("creditSimulator.resetButtonText")}</span>
                            </button>
                        </div>
                    </div>
                </form>
                <div id="simulate-score-output" className="margin-top-l" role="alert" aria-live="polite" aria-atomic="true">
                    <h3 className="box-title">Current Score</h3>
                    <div className="current-score">
                        {currentScore !== -1 ? <span>{currentScore}</span> :
                             ("")
                    }
                    </div>
                    <div className="line-divider margin-vertical-s" id="simulated-score-divider" style={{ display: "none" }}></div>
                    <h3 className="box-title" id="title-simulated-score" style={{ display: "none" }}>
                        Simulated Score
                    </h3>
                    <div className="simulated-score" role="status" id="simulated-score" aria-labelledby="title-simulated-score" style={{ display: "none" }}>
                        <span>0</span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            {isCreditScoreSimulatorActive === true ? (
                <>
                    <div id="content" className={`${isLoading ? "row loading" : "row"}`}>
                        <div className="col-xs">
                            <div className="box offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="file-invoice" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("creditSimulator.title")}</h2>
                                        </div>
                                    </div>
                                </div>
                                <React.Fragment>{renderMessageScreen()}</React.Fragment>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="row" id="content">
                        <div className="col-xs-12">
                            <div className="box">
                                <div className="text-align-center">
                                    <div className="color-alert msg-small margin-top-xs">
                                        <RenderIcons iconName="info-circle" /> This feature is not included in your subscription.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </React.Fragment>
    );
};

export default CreditSimulator;
